<script setup>
    import { useI18n } from 'vue-i18n';
    import { storeToRefs } from 'pinia'
    import { useStageStore } from '@/stores/stage';
    import router from '@/router';
    import { useForm } from 'vee-validate';

    const formStorage = useStageStore();
    const { t } = useI18n()
    const { answerId, answerToken } = storeToRefs(formStorage)

    // Create the form
    const { defineInputBinds, handleSubmit } = useForm({
        validationSchema: {
            formPassword: () => true, // no local validation for password field
        },
    });

    // Submit handler
    const onSubmit = handleSubmit(async (values) => {
        const password = values.formPassword;
      
        const passwordSent = await formStorage.sendSurveyFormData({
            [`${formStorage.getNameSpace}cmd`]: 'edit',
            [`${formStorage.getNameSpace}uuid`]: formStorage.getSurveyAnswerUuid,
            [`${formStorage.getNameSpace}password`]: password,
            [`${formStorage.getNameSpace}answerId`]: answerId,
            [`${formStorage.getNameSpace}answerToken`]: answerToken
        })
                
        if (!passwordSent) {
            formStorage.passwordFailed = true;
            return;
        }
        
        // Hide password form, allow loaded survey data to be shown
        formStorage.showPasswordForm = false;
        formStorage.passwordFailed = false;
    });

    // Define fields
    const formPassword = defineInputBinds('formPassword');

    const cancelPassword = () => {

        // Load default survey
        formStorage.getSurveyFormData(formStorage.answerURL)

        formStorage.showPasswordForm = false;
        
        router.push({name: 'home'})
    }
</script>

<template>
    <form
        id="submit-password-form"
        @submit="onSubmit"
        class="column"
    >
        <div class="column mb-4 submit-password">
            <label for="formPassword" class="primary-label">{{ t('draft-form.input.draft-password') }}</label>
            <input 
                id="formPassword" 
                type="password"
                required
                :class="formStorage.passwordFailed ? 'has-error': ''" 
                v-bind="formPassword" 
                :placeholder="t('draft-form.info.give-password')"
            >
            <span v-if="formStorage.passwordFailed">{{ t('draft-form.validation.password-failed') }}</span>
        </div>

        <div class="row">
            <button @click="cancelPassword()" class="btn btn-secondary" type="button">{{ t('button.cancel') }}</button>
            <button class="btn btn-primary" type="submit">{{ t('button.send') }}</button>
        </div>
    </form>
</template>